"use client";

import { useCart } from "@trydig/centra/client";
import styles from "./CartIndicator.module.css";

export const CartIndicator = () => {
	const { data } = useCart();

	const count = data?.items.reduce(
		(acc, value) => acc + (value.quantity ?? 0),
		0,
	);

	return <div className={styles.root}>{count ?? 0}</div>;
};
